// extracted by mini-css-extract-plugin
module.exports = {"form-group":"styles_form-group__aQmjM","loader":"styles_loader__2F5yq","errorText":"styles_errorText__Kl-pg","hintText":"styles_hintText__1pgsM","button":"styles_button__2ZBRg"};